import { useNavigate } from 'react-router-dom'
import { ChevronBox } from '../../components/fd/ftux/ChevronBox'
import { TopBar } from '../../components/fd/ftux/TopBar'
import { FD_IMAGE_URL } from '../../constants'
import { onReady, trackEvent, updateAppStatusBar } from '../../utils/appBridge'
import { FDFTUXType } from '../../types/fd-ftux.types'
import { EventNames } from '../../types/misc.types'
import { useEffect } from 'react'

const chevronBoxes = [
  {
    id: FDFTUXType.TRADITIONAL_FDs,
    icon: `${FD_IMAGE_URL}/bank-account-icon.svg`,
    text: 'Yes, in traditional FDs'
  },
  {
    id: FDFTUXType.BONDS_DEBT_MFs,
    icon: `${FD_IMAGE_URL}/debt-fund-icon.svg`,
    text: 'No, I prefer bonds & debt mutual fund'
  },
  {
    id: FDFTUXType.EQUITY,
    icon: `${FD_IMAGE_URL}/equity-icon.svg`,
    text: 'No, I only invest in Equity'
  }
]

const ScreenName = 'FD_FTUX_HOME_PAGE'

export const FDFTUXHomePage = () => {
  const navigate = useNavigate()
  updateAppStatusBar('0767C5', 'light')
  useEffect(() => {
    trackEvent({ eventName: EventNames.ScreenLoaded, payload: { ScreenName } })
    setTimeout(() => {
      onReady()
    }, 100)
  }, [])

  return (
    <div style={{ background: 'linear-gradient(180deg, #0767C5 0%, #119DE3 100%)' }} className='w-full h-screen'>
      <div className="flex flex-col h-full w-full bg-[url('/images/fd/bg-lines.svg')] bg-contain bg-no-repeat bg-blend-soft-light">
        <TopBar ScreenName={ScreenName} />
        <div className='flex flex-col flex-1 justify-center items-center pb-24 animate-fade-550'>
          <div className='text-white text-[36px] font-[500] leading-[130%] text-center'>
            Do you invest <br /> in FDs?
          </div>
          <div className='flex flex-col gap-3 w-full px-10 pt-7'>
            {chevronBoxes?.map(({ icon, text, id }, idx) => {
              return (
                <div
                  onClick={() => {
                    trackEvent({
                      eventName: EventNames.ButtonTap,
                      payload: { buttonLabel: `${text}`, ScreenName }
                    })
                    navigate(`/fd-ftux/${id}`)
                  }}
                  key={`${icon}-${text}-${idx}`}
                >
                  <ChevronBox iconUrl={icon} text={text} />
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
